/**
 * @generated SignedSource<<d112bd38133460e9b1f418d1a0d3d742>>
 * @relayHash 582857242705e01503c7d88b1d38efef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4a495fe774ef9c9f77bc0cdf87ee72298026bea52917b8c128d6a1156eb021aa

import type { ConcreteRequest } from 'relay-runtime';
export type duplicate_hasVersionCapabilityQuery$variables = {
  cloudId: string;
};
export type duplicate_hasVersionCapabilityQuery$data = {
  readonly agentStudio_hasVersionCapability: {
    readonly __typename: "AgentStudioHasVersionCapability";
    readonly hasVersionCapability: boolean | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type duplicate_hasVersionCapabilityQuery = {
  response: duplicate_hasVersionCapabilityQuery$data;
  variables: duplicate_hasVersionCapabilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "kind": "LinkedField",
    "name": "agentStudio_hasVersionCapability",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasVersionCapability"
          }
        ],
        "type": "AgentStudioHasVersionCapability"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "duplicate_hasVersionCapabilityQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "duplicate_hasVersionCapabilityQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "4a495fe774ef9c9f77bc0cdf87ee72298026bea52917b8c128d6a1156eb021aa",
    "metadata": {},
    "name": "duplicate_hasVersionCapabilityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "37de4ac9fc58ea6085ef3eacae3ccfd5";

export default node;
